import {Component} from '@angular/core';
import {Store} from '@ngrx/store';
import {authFeature} from '@auth/store';
import {EnvironmentService} from '@core/services/environment.service';
import {selectEntiteBySiret, selectIsGroup, selectIsMonoSiret,} from '@features/referentiel/features';
import {AsyncPipe} from '@angular/common';
import {MonCompteFormComponent} from '@features/compte/mon-compte/components/mon-compte-form/mon-compte-form.component';
import {MaintenanceActions} from '@features/maintenance/store/maintenance.actions';
import Keycloak from 'keycloak-js';

@Component({
  standalone: true,
    selector: 'app-mon-compte',
    templateUrl: './mon-compte.component.html',
    styleUrls: ['./mon-compte.component.scss'],
    imports: [MonCompteFormComponent, AsyncPipe]
})
export class MonCompteComponent {
  user$ = this.store$.select(authFeature.selectUser);
  entite$ = this.store$.select(selectEntiteBySiret);
  isGroup$ = this.store$.select(selectIsGroup);
  isMonoSiret$ = this.store$.select(selectIsMonoSiret);

  constructor(
    private store$: Store,
    private keycloak: Keycloak,
    private env: EnvironmentService,
  ) {}

  onDeconnect() {
    this.keycloak.logout( {redirectUri : this.env.host});
    this.store$.dispatch(MaintenanceActions.loadMaintenance());
  }
}
